import React, { useState } from 'react';
import { useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import $ from 'jquery';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'relative',
    left: 50,
    top: 50,
    width: 350,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SimpleModal({state, setReCAPTCHAToken, onReCAPTCHAClose}) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const captcha_display = state.captcha_display;
  const [open, setOpen] = React.useState(captcha_display);
  const captchaRef = useRef(null);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    onReCAPTCHAClose();
  };

  useEffect(()=>{
    console.log('display captcha:', state.captcha_display)
    setOpen(captcha_display);
  },[captcha_display])



   const recaptchaChecked = () => {
        console.log('reCAPTCHA checked');
        const token = captchaRef.current.getValue();
        //send to validate
        setReCAPTCHAToken({token});

        captchaRef.current.reset();
    }
  

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='center'><h4 id="simple-modal-title">Verify your identity</h4></div>
      <div className='centerRe'>
	  <ReCAPTCHA sitekey="6LeZPFQpAAAAAP_2rsIpjB6M8dk0tjLM3li_GcXi" onChange={recaptchaChecked} ref={captchaRef}/>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/PeopleClient/reCAPTCHA.js